import { useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  ButtonBase,
  ClickAwayListener,
  Popper,
  Fade
} from '@mui/material';

// project import
import ToDoList from 'components/worten/ToDoList';
import Transitions from 'components/@extended/Transitions';

// store
import useAuth from 'hooks/useAuth';

// icons
import { MdTaskAlt } from "react-icons/md";

const TaskButton = () => {
  const theme = useTheme();
  const anchorRef = useRef(null);
  
  const [open, setOpen] = useState(false);
  
  //Role validation
  const { user, ValidateRole } = useAuth();
  const authorizedRoles = [1, 100];
  let validation = ValidateRole(user?.role, authorizedRoles);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  // If user doesn't have authorized role, don't render the component
  if (validation !== true) return null;

  return (
    <>
      <Box sx={{ flexShrink: 0, ml: 0.75 }}>
        <ButtonBase
          sx={{
            p: 0.25,
            borderRadius: 1,
            '&:hover': { 
              bgcolor: theme.palette.mode === 'dark' ? 'secondary.light' : 'secondary.lighter' 
            },
            '&:focus-visible': {
              outline: `2px solid ${theme.palette.secondary.dark}`,
              outlineOffset: 2
            }
          }}
          aria-label="open tasks"
          ref={anchorRef}
          aria-controls={open ? 'tasks-popover' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <MdTaskAlt style={{ fontSize: '1.5rem' }} />
        </ButtonBase>
      </Box>
      
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 9]
              }
            }
          ]
        }}
        sx={{ zIndex: 1100 }}
      >
        {({ TransitionProps }) => (
          <Transitions type="fade" in={open} {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <Box>
                  <ToDoList 
                    usuarioId={user?.id || 1} 
                    maxRows={8} 
                  />
                </Box>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </>
  );
};

export default TaskButton;

// Styled Paper component with fade transition
const Paper = ({ children, sx, ...other }) => {
  return (
    <Fade in>
      <Box
        sx={{
          boxShadow: '0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12)',
          minWidth: 285,
          maxWidth: 420,
          width: '100%',
          borderRadius: 1.5,
          ...sx
        }}
        {...other}
      >
        {children}
      </Box>
    </Fade>
  );
};
